import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

const SpecifIcation = ({ description }) => {
  const [show, setShow] = useState(false);

  return (
    <Dropdown
      show={show}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{ background: 'transparent' }}
     >
      <Dropdown.Toggle id="dropdown-basic"  style={{ background: "transparent", border: "none", color: "#5f6367", fontSize: "18px" }}>
        SPECIFICATION
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ padding: "5px", width: "100%",  background: "#0000006b", color: "#FFF"}}>
        {description}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SpecifIcation;
